import axios from 'axios'
import { IhLogUrl } from '@/api/config'
import { errorCollection } from '@/api/dmp/dmpCollection'
// 试用版查询智能分析媒体文件数据列表
export function findAnalyseMediaTrial(params) {
  const url = IhLogUrl + '/analyse/media/trial'
  return axios({
    method: 'post',
    url: url,
    data: params
  }).then(res => {
    if (res.status !== 200) {
      errorCollection('焦点关注', '试用版查询智能分析媒体文件数据列表', { status: res.status, data: { state: -1, msg: '批量导入设备失败' } })
    }
    return Promise.resolve(res.data)
  })
}
// 正式版查询智能分析媒体文件数据列表
export function findAnalyseMediaList(params) {
  const url = IhLogUrl + '/analyse/media'
  return axios({
    method: 'post',
    url: url,
    data: params
  }).then(res => {
    if (res.status !== 200) {
      errorCollection('图像检索', '正式版查询智能分析媒体文件数据列表', { status: res.status, data: { state: -1, msg: '批量导入设备失败' } })
    }
    return Promise.resolve(res.data)
  })
}